const recorderCandidates = [
  'video/mp4;codecs="avc1.42E01E"',
  "video/mp4",
  "video/webm;codecs=vp9",
  "video/webm;codecs=vp8",
  "video/webm"
];

export function detectBrowserCapabilities() {
  const canvas = document.createElement("canvas");
  const canvasCaptureStream = typeof canvas.captureStream === "function";
  const mediaRecorder = typeof window.MediaRecorder !== "undefined";
  const supportedRecorderTypes = mediaRecorder
    ? recorderCandidates.filter((type) => window.MediaRecorder.isTypeSupported(type))
    : [];

  return {
    canvasCaptureStream,
    mediaRecorder,
    recorderCandidates,
    secureContext: window.isSecureContext,
    supportedRecorderTypes,
    userAgent: navigator.userAgent,
    webCodecs: "VideoEncoder" in window && "VideoDecoder" in window,
    webgl: Boolean(canvas.getContext("webgl")),
    webgl2: Boolean(canvas.getContext("webgl2"))
  };
}

export function preferredRecorderMimeType() {
  if (typeof window.MediaRecorder === "undefined") return "";
  return recorderCandidates.find((type) => window.MediaRecorder.isTypeSupported(type)) ?? "";
}
